<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">退订</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('compute.text_92')" :count="params.data.length" :action="this.params.title" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('compute.text_1041')" v-bind="formItemLayout" v-if="isOpenWorkflow">
          <a-input v-decorator="decorators.reason" :placeholder="$t('compute.text_1105')" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ confirmText }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import WorkflowMixin from '@/mixins/workflow'
import { findPlatform } from '@/utils/common/hypervisor'

export default {
  name: 'UnsubscribeBaremetalDialog',
  mixins: [DialogMixin, WindowsMixin, WorkflowMixin],
  data () {
    const isVmware = this.params.data[0].hypervisor === 'esxi'
    return {
      loading: false,
      disableDelete: isVmware,
      form: {
        fc: this.$form.createForm(this),
        fd: {
          autoDelete: false,
          deleteEip: false,
          deleteSnapshot: false,
          deleteDisk: false,
        },
      },
      decorators: {
        autoDelete: [
          'autoDelete',
          {
            valuePropName: 'checked',
            initialValue: isVmware,
          },
        ],
        reason: [
          'reason',
          {
            initialValue: '',
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
      formItemLayoutWithoutLabel: {
        wrapperCol: {
          span: 19,
          offset: 5,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'userInfo']),
    type () {
      console.log(this.params)
      const brand = this.params.data[0].brand
      return findPlatform(brand)
    },
    isOpenWorkflow () {
      return this.checkWorkflowEnabled(this.WORKFLOW_TYPES.APPLY_SERVER_DELETE)
    },
    confirmText () {
      return this.isOpenWorkflow ? this.$t('compute.text_288') : this.$t('dialog.ok')
    },
    disableToolTip () {
      if (this.disableDelete) {
        return this.$t('compute.disable_delete_snapshot_tooltip')
      }
      return ''
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.handleUnsubscribe()
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    // async handleDeleteByWorkflowSubmit () {
    //   const ids = this.params.data.map(item => item.id)
    //   const values = await this.form.fc.validateFields()
    //   const variables = {
    //     project: this.params.data[0].tenant_id,
    //     project_domain: this.params.data[0].domain_id,
    //     process_definition_key: this.WORKFLOW_TYPES.APPLY_SERVER_DELETE,
    //     initiator: this.userInfo.id,
    //     ids: ids.join(','),
    //     description: values.reason,
    //   }
    //   await this.createWorkflow(variables)
    //   this.$message.success(this.$t('compute.text_1214'))
    //   this.$router.push('/workflow')
    // },
    async handleUnsubscribe () {
      console.log(this.params)
      if (this.params.ok) {
        await this.params.ok()
      } else {
        const id = this.params.data[0].id
        await this.$http({
          method: 'POST',
          url: `/sa/bill/api/v1/asset/${id}/unsubscribe`,
        })
      }
      //   const ids = this.params.data.map(item => item.id)
      //   await this.form.fc.validateFields()
      //   let params = {}
      //   params = {
      //     ...params,
      //     ...this.params.requestParams,
      //   }
      //   if (this.form.fd.deleteSnapshot || (this.deleteSnapshotLimit.support && this.deleteSnapshotLimit.mustDelete)) {
      //     params.delete_snapshots = true
      //   }
      //   if (this.form.fd.deleteDisk || (this.deleteDiskLimit.support && this.deleteDiskLimit.mustDelete)) {
      //     params.delete_disks = true
      //   }
      //   if (this.form.fd.deleteEip || (this.deleteEipLimit.support && this.deleteEipLimit.mustDelete)) {
      //     params.delete_eip = true
      //   }
      //   const response = await this.params.onManager('batchDelete', {
      //     id: ids,
      //     managerArgs: { params },
      //   })
      //   if (this.params.vm && this.params.vm.destroySidePages) {
      //     this.params.vm.destroySidePage(this.params.vm.windowId)
      //   }
      //   if (this.params.success && R.is(Function, this.params.success)) {
      //     this.params.success(response)
      //   }
      // }
      this.$message.success(this.$t('compute.text_423'))
    },
  },
}
</script>
